export default {
  // eslint-disable-next-line no-unused-vars
  startTransaction(appId) {
    return new Promise(resolve => resolve({
      'dunia-income-verification-id': '092C3E68-809A-4872-9A43-9C5534458470',
      'vendor-income-verification-id': 'HFTN1559819439195',
    }));
  },
  // eslint-disable-next-line no-unused-vars
  completeTransaction(appId) {
    return new Promise(resolve => resolve({
      'app-id': 'BA094051-5307-4CFB-9103-C54004FCC376',
      'dunia-income-verification-id': 'BA470051-5307-4CFB-9103-C54004FCC376',
      'vendor-income-verification-id': 'JKAZ1559319825515',
    }));
  },
};
